import React, { Suspense, useState, useEffect } from 'react';
import { View } from 'react-native';
import MultiFeatureCard from '../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import SunBurstWrapper from './SunBurstWrapper';
import { transformTopicsData } from './utils';
import useFetchAiAnalyticsWidgetData from '../../../hooks/useFetchAiAnalyticsWidgetData';
import GenericNoData from '../../../../../components/Common/NoData/GenricNoData';
import get from 'lodash/get';

const TopicHierarchy = props => {
  const { itemData, timeperiodLabel, applied_filter_values } = props;
  const [transformedData, setTransformedData] = useState([]);

  const { data, isLoading } = useFetchAiAnalyticsWidgetData({
    widgetId: itemData?.widgetId,
    appliedFilterValues: applied_filter_values,
    widget_config: {}
  });

  useEffect(() => {
    if (isLoading) return;
    try {
      if (!data?.rows?.length || !data?.hierarchy?.length) {
        setTransformedData([]);
        return;
      }
      setTransformedData(transformTopicsData(data));
    } catch (e) {
      setTransformedData([]);
    }
  }, [data, isLoading]);

  const shouldRender = !isLoading && transformedData.length > 0;

  return (
    <View>
      <MultiFeatureCard
        title={itemData?.title || 'Topic Hierarchy With Sentiment and Phrases'}
        subTitle={timeperiodLabel}
        loading={isLoading}
        style={{ childContainer: { minHeight: 250 } }}
        isNoData={!isLoading && !transformedData.length > 0}
        renderContent={() =>
          (shouldRender) ? (
            <Suspense fallback={null}>
              <SunBurstWrapper
                seriesLevel={get(itemData, "seriesLevel", [])}
                chartDefaultConfig={get(itemData, "chartDefaultConfig", {})}
                topics_hierarchy_data={transformedData} />
            </Suspense>
          ) : (
            null
          )
        }
      />
    </View>
  );
};

export default TopicHierarchy;
